import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


export default {

outinRecord: ( id ) => AjaxPlugin.$http.post( `/api/parklot/wx/outinRecord/list/` + id ),

payRecord: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/payrecord/list`, data ),

monthRecord: ( data ) => AjaxPlugin.$http.post( `/api/wx/parklot/vehicle/list`, data ),

vipRecord: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/viprecord/list/` + data ),

addCar: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/vehicle/addBind`, data ),

carData: ( id ) => AjaxPlugin.$http.post( `/api/parklot/wx/vehicle/wxBindAll/` + id ),

deleteBind: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/vehicle/deleteBind`, data ),

queryMainParklot: () => AjaxPlugin.$http.get( `/api/parklot/wx/parklot/queryMainParklot` )
};



// WEBPACK FOOTER //
// ./src/api/personInfo.js